(function () {
  'use strict';

  angular.module('app').component('tourDetail', tourDetail());

  function tourDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        activeTab: '<',
        onSavedItem: '&',
        onCanceledItem: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
        userLanguageCode: '<',
      },
      controller: TourDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tours/tour-detail/tour-detail.component.html',
    };
  }

  TourDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ModalWindowConfirmService',
    'TourService',
    'TourOptionService',
    'TourContentService',
    'MeasurementUnitService',
    'SessionService',
    'ProductCategoryService',
    'TaxService',
    'ProductService',

    // Angular downgraded service
    'categoryService',
    'categoryModalService',
    'facilityService',
    'facilityModalService',
    'whatToBringService',
    'whatToBringModalService',
    'zoneService',
    'zoneModalService',
    'pickupPlaceService',
    'locationService',
    'locationModalService',
    'utilService',
    'companyService',
  ];

  function TourDetailComponent(
    config,
    UtilService,
    ModalWindowConfirmService,
    TourService,
    TourOptionService,
    TourContentService,
    MeasurementUnitService,
    SessionService,
    ProductCategoryService,
    TaxService,
    ProductService,

    // Angular downgraded service
    categoryService,
    categoryModalService,
    facilityService,
    facilityModalService,
    whatToBringService,
    whatToBringModalService,
    zoneService,
    zoneModalService,
    pickupPlaceService,
    locationService,
    locationModalService,
    utilService,
    companyService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.activeStatus = config.ACTIVE;
    vm.inactiveStatus = config.INACTIVE;

    vm.timeOptions = config.TIME_OPTIONS;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.costBasedTypes = config.COST_BASED_TYPES;

    vm.checkedCategory = {};
    vm.checkedFacility = {};
    vm.checkedWhatToBring = {};

    // Methods
    vm.selectProductCategory = selectProductCategory;
    vm.openProductCategoriesModal = openProductCategoriesModal;

    vm.openTourOptionModal = openTourOptionModal;
    vm.changeTourOptionStatus = changeTourOptionStatus;
    vm.deleteTourOption = deleteTourOption;

    vm.openLocationsModal = openLocationsModal;
    vm.selectLocation = selectLocation;
    vm.openZonesModal = openZonesModal;

    vm.openTourContentsModal = openTourContentsModal;

    vm.editTour = editTour;
    vm.cancelEdit = cancelEdit;
    vm.saveTour = saveTour;
    vm.cancel = cancel;

    vm.selectAssociatedProviders = selectAssociatedProviders;
    vm.onAssociatedProviderSaved = onAssociatedProviderSaved;
    vm.onAssociatedProviderDeleted = onAssociatedProviderDeleted;
    vm.onSelectedTab = onSelectedTab;

    vm.selectAssociatedServiceItems = selectAssociatedServiceItems;
    vm.onAssociatedServiceItemSaved = onAssociatedServiceItemSaved;
    vm.onAssociatedServiceItemDeleted = onAssociatedServiceItemDeleted;

    vm.selectAssociatedTaxes = selectAssociatedTaxes;
    vm.onAssociatedTaxesSaved = onAssociatedTaxesSaved;
    vm.onAssociatedTaxesCanceled = onAssociatedTaxesCanceled;
    vm.selectAccounting = selectAccounting;

    vm.selectCostsAndPrices = selectCostsAndPrices;
    vm.onCostsAndPricesSaved = onCostsAndPricesSaved;

    vm.$onInit = function () {
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.item.id) {
        // Edit
        vm.active = vm.activeTab ? parseInt(vm.activeTab) : 0;

        // Order by name asc, lowering first
        vm.item.tour_options = vm.item.tour_options.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );

        setItemOptions(vm.item, vm.mode);
        getServerData(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.item = {
          service_items_cost_based: null,
          company_id: SessionService.getSelectedAccountCompany().id,
        };

        // Initializers
        getLocations();
        // getPickupPlaces('');
        getProductCategories('');
      }

      // Initializers
      getCompany();

      getRelatedTours();

      getCategories();
      getFacilities();
      getWhatToBrings();
    };

    vm.openSearchCabys = function (item) {
      const succesCallBack = (itemObj) => {
        vm.item.cabys_code = itemObj.codigo;
        vm.item.cabys_description = itemObj.descripcion;
        vm.item.cabys_tax = itemObj.impuesto;
      };

      ProductService.openSearchCabys(item, succesCallBack);
    };

    vm.searchCabys = function () {
      if (!vm.item.cabys_code || vm.item.cabys_code.length < 13) return;

      let searchBy = 'codigo=' + vm.item.cabys_code.toLowerCase();

      vm.clearCabys();

      vm.invalidCabys = false;

      vm.searchingCabys = true;
      ProductService.searchCabys(searchBy).then(function (data) {
        // console.log(data);
        if (data[0] && data[0].codigo) {
          vm.item.cabys_code = data[0].codigo;
          vm.item.cabys_description = data[0].descripcion;
          vm.item.cabys_tax = data[0].impuesto;

          vm.invalidCabys = false;
        } else {
          vm.invalidCabys = true;
        }

        vm.searchingCabys = false;
      });
    };

    vm.clearCabys = function () {
      vm.item.cabys_description = '';
      vm.item.cabys_tax = '';
    };

    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editMode = true;

        editTour();
      }

      vm.productIsExempt = item.is_exempt || false;

      vm.productCategorySelected = item.product_category;
      vm.serviceItemsCostBasedEvaluated = item.service_items_cost_based ? true : false;

      setCheckedCategories(item.category_ids);
      setCheckedFacilities(item.facility_ids);
      setCheckedWhatToBring(item.what_to_bring_ids);

      checkAssociatedServiceItemsSchedulesApplied();

      vm.customTaxConfiguration = item.custom_tax_configuration;

      vm.itemName = item.name;

      vm.originalItem = angular.copy(item); // store server data

      vm.flashMessage = vm.UtilService._displayFlashMessage();
    }

    function getServerData(item) {
      if (item.location_id) {
        getZonesByLocation(item.location_id);

        getPickupPlacesByLocation(item.location_id);
      }

      // To reload code number consecutive
      getProductCategories('');
    }

    function editTour() {
      vm.editMode = true;
      vm.viewMode = false;

      // Initializers
      getLocations();
    }

    function cancelEdit() {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    }

    // Show alert if not schedules has been assigned to any associated service items
    function checkAssociatedServiceItemsSchedulesApplied() {
      if (vm.item.service_items_cost_based) {
        vm.invalidServiceItemsSchedulesApplied = false;

        var valid = true;
        for (var i = vm.item.associated_service_items.length - 1; i >= 0; i--) {
          if (vm.item.associated_service_items[i].appliedTo === 0) {
            valid = false;
            break;
          }
          /*if (vm.item.associated_service_items[i].appliedTo > 0){
                        valid = true;
                        break;
                    } */
        }

        if (!valid) {
          vm.invalidServiceItemsSchedulesApplied = true;
        }
      }
    }

    function getCompany() {
      companyService
        .getCompany(vm.item.company_id, {
          skip_check_role: true,
          lang: vm.userLanguageCode,
        })
        .subscribe((response) => {
          // vm.defaultLanguage
          if (response.country.country_setting) {
            vm.taxTypes = response.country.country_setting.tax_types;
            vm.taxRateCodes = response.country.country_setting.tax_rate_codes;
          }

          vm.measurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
            response.measurement_units,
            'tour'
          );

          if (!vm.createMode) {
            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              vm.item.measurement_unit_id
            );
          }
        });
    }

    // ----- PRODUCT CATEGORIES -----

    function getProductCategories(option) {
      var params = {
        get: 'active',
        by_product_type: 'tour',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingProductCategories = true;
      ProductCategoryService.getProductCategories(params).then(function (data) {
        vm.productCategories = data.items;
        vm.loadingProductCategories = false;

        if (option === 'update') {
          var productCategory = vm.UtilService.findItemInArray(
            vm.productCategories,
            'id',
            vm.productCategorySelected.id
          );
          vm.productCategorySelected = null;
          selectProductCategory(productCategory);
        }
      });
    }

    function selectProductCategory(productCategory) {
      if (vm.productCategorySelected && vm.productCategorySelected.id === productCategory.id) {
        // Same product category is selected
        return;
      }

      vm.productCategorySelected = productCategory;

      vm.item.code_number = '';

      // Edit mode
      if (vm.editMode) {
        // Same product category as the item
        if (vm.originalItem.product_category_id === productCategory.id) {
          vm.item.code = vm.originalItem.code;
          vm.item.code_number = vm.originalItem.code_number;
        } else if (productCategory.coding_type === 'automatic') {
          vm.item.code =
            productCategory.coding_prefix + productCategory.nextProductCodeNumberToAssign;
          vm.item.code_number = productCategory.nextProductCodeNumberToAssign;
        }
      }
    }

    function openProductCategoriesModal() {
      var successCallback = function () {
        getProductCategories('update');
      };

      ProductCategoryService.openProductCategoriesModal(successCallback);
    }

    // ----- TOURS -----

    function getRelatedTours() {
      var params = {
        get: 'all',
        tourId: vm.item.id,
        skip_check_role: true,
      };

      vm.loadingTours = true;
      TourService.getTours(params).then(function (data) {
        vm.tours = data.items;

        vm.loadingTours = false;
      });
    }

    function openTourContentsModal() {
      TourContentService.openTourContentsModal(vm.item);
    }

    // ----- TOUR OPTIONS -----

    function openTourOptionModal(option) {
      var successCallback = function (selectedItem) {
        vm.item.tour_options = selectedItem.tour_options;
      };

      var item = angular.copy(option); // To keep diferent scope
      TourOptionService.openTourOptionModal(
        vm.item,
        item,
        vm.userLanguageCode,
        vm.additionalLanguages,
        successCallback
      ); // , vm.defaultLanguage
    }

    function changeTourOptionStatus(option) {
      TourOptionService.changeTourOptionStatus(vm.item.id, option);
    }

    function deleteTourOption(option, index) {
      var successCallback = function () {
        vm.item.tour_options.splice(index, 1);
      };

      TourOptionService.deleteTourOption(vm.item, option, successCallback);
    }

    // ----- LOCATIONS -----

    function getLocations() {
      if (vm.locations) {
        return;
      }

      var params = {
        get: 'active',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      vm.loadingLocations = true;
      locationService.getLocations(params).subscribe((response) => {
        vm.locations = locationService.groupLocations(response); // , '', 'locations'
        vm.loadingLocations = false;
      });
    }

    function openLocationsModal() {
      var successCallback = function () {
        vm.locations = null;
        getLocations();
      };

      locationModalService.openLocationsModal(successCallback);
    }

    function selectLocation(locationId) {
      vm.item.zone_id = null;
      getZonesByLocation(locationId);

      getPickupPlacesByLocation(locationId);
    }

    function getZonesByLocation(locationId) {
      var params = {
        get: 'by_location',
        location_id: locationId,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      zoneService.getZones(params).subscribe((response) => {
        vm.zones = response;
      });
    }

    function openZonesModal() {
      var successCallback = function () {
        getZonesByLocation(vm.item.location_id);
      };

      zoneModalService.openZonesModal(successCallback);
    }

    function getPickupPlacesByLocation(locationId) {
      var params = {
        get: 'active',
        location_id: locationId,
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      if (locationId) {
        params.location_id = locationId;
      }

      vm.loadingPickupPlaces = true;
      pickupPlaceService.getPickupPlaces(params).subscribe((response) => {
        vm.pickupPlaces = response;
        vm.dropoffPlaces = vm.pickupPlaces;

        vm.defaultPickupPlace = vm.pickupPlaces.find(
          (x) => x.id === vm.item.default_pickup_place_id
        );
        vm.defaultDropoffPlace = vm.dropoffPlaces.find(
          (x) => x.id === vm.item.default_dropoff_place_id
        );

        vm.defaultPickupPlaceName = vm.defaultPickupPlace ? vm.defaultPickupPlace.name : '-';
        vm.defaultDropoffPlaceName = vm.defaultDropoffPlace ? vm.defaultDropoffPlace.name : '-';

        vm.loadingPickupPlaces = false;
      });
    }

    // ----- CATEGORIES -----

    function getCategories() {
      var params = {
        get: 'tour',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      categoryService.getCategories(params).subscribe((response) => {
        vm.categories = response;
      });
    }

    vm.openCategoriesModal = function () {
      const successCallback = () => {
        getCategories();
      };

      categoryModalService.openCategoriesModal(successCallback);
    };

    function setCheckedCategories(category_ids) {
      category_ids.forEach((key) => {
        vm.checkedCategory[key] = true;
      });
    }

    // ----- FACILITIES -----

    function getFacilities() {
      var params = {
        get: 'tour',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      facilityService.getFacilities(params).subscribe((response) => {
        vm.facilities = response;
      });
    }

    vm.openFacilitiesModal = function () {
      const successCallback = () => {
        getFacilities();
      };

      // const params = {
      //   // lang: vm.defaultLanguage,
      //   lang: vm.userLanguageCode,
      // };
      // params,

      facilityModalService.openFacilitiesModal(successCallback);
    };

    function setCheckedFacilities(facility_ids) {
      facility_ids.forEach((key) => {
        vm.checkedFacility[key] = true;
      });
    }

    // ----- WHAT TO BRING -----

    function getWhatToBrings() {
      var params = {
        get: 'tour',
        skip_check_role: true,
        // lang: vm.defaultLanguage
        lang: vm.userLanguageCode,
      };

      whatToBringService.getWhatToBrings(params).subscribe((response) => {
        vm.whatToBrings = response;
      });
    }

    vm.openWhatToBringsModal = function () {
      const successCallback = () => {
        getWhatToBrings();
      };

      whatToBringModalService.openWhatToBringsModal(successCallback);
    };

    function setCheckedWhatToBring(what_to_bring_ids) {
      what_to_bring_ids.forEach(function (key) {
        vm.checkedWhatToBring[key] = true;
      });
    }

    // Create/Update
    function saveTour(isFormValid) {
      vm.formErrors = false;

      if (
        !isFormValid ||
        vm.productCategories.length === 0 ||
        vm.locations === 0
        // || !vm.item.zone_id
        //|| (vm.atvCrEnabled && !vm.item.cabys_description)
      ) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();
        return;
      }

      vm.item.default_pickup_place_id = vm.item.default_pickup_place_id || null;
      vm.item.default_dropoff_place_id = vm.item.default_dropoff_place_id || null;

      // console.log(vm.item); return;

      if (
        vm.editMode &&
        !vm.item.service_items_cost_based &&
        vm.item.associated_service_items.length > 0
      ) {
        var params = {
          mode: 'danger',
          title: 'UPDATE_COST_TYPE',
          body: 'UPDATE_COST_TYPE_WARNING',
        };

        var successCallback = function () {
          vm.item.associated_service_items = [];
          saveTourApi();
        };

        var cancelCallback = function () {
          cancelEdit();
        };

        // Just in case the users want to modify the cost type with associated service items
        ModalWindowConfirmService.open(params, successCallback, cancelCallback);
      } else {
        saveTourApi();
      }
    }

    function saveTourApi() {
      vm.item.category_ids = utilService.parseItemIds(vm.checkedCategory);
      vm.item.facility_ids = utilService.parseItemIds(vm.checkedFacility);
      vm.item.what_to_bring_ids = utilService.parseItemIds(vm.checkedWhatToBring);

      // var geo_lat = <HTMLInputElement>document.getElementById('geo_lat');
      // var geo_lng = <HTMLInputElement>document.getElementById('geo_lng');
      // var geo_zoom = <HTMLInputElement>document.getElementById('geo_zoom');

      // vm.item.geo_lat = geo_lat.value;
      // vm.item.geo_lng = geo_lng.value;
      // vm.item.geo_zoom = geo_zoom.value;

      vm.item.geo_lat = document.getElementById('geo_lat').value;
      vm.item.geo_lng = document.getElementById('geo_lng').value;
      vm.item.geo_zoom = document.getElementById('geo_zoom').value;

      vm.sendingForm = true;
      TourService.saveTour(vm.item).then(function (data) {
        var status = data.status;
        var response = data.response;

        if (status) {
          // Success
          if (!vm.editMode) {
            // create
            vm.onSavedItem({ item: response });
          } else {
            vm.item = response;
            setItemOptions(response);

            vm.measurementUnit = vm.UtilService.findItemInArray(
              vm.measurementUnits,
              'id',
              response.measurement_unit_id
            );

            getServerData(response);

            vm.flashMessage = vm.UtilService._clearFlashMessage();
            vm.UtilService.scrollToTop();
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;

          vm.UtilService.scrollToTop();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onCanceledItem({ item: vm.item });
    }

    // ----- ASSOCIATED PROVIDERS -----

    function selectAssociatedProviders() {
      vm.showAssociatedProviders = true;
    }

    function onAssociatedProviderSaved(product, items) {
      vm.item.default_provider_id = product.default_provider_id;

      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onAssociatedProviderDeleted(items) {
      vm.item.associated_providers = items;
      vm.originalItem.associated_providers = items;
    }

    function onSelectedTab(tab) {
      vm.active = tab;
    }

    // ----- ASSOCIATED SERVICE ITEMS -----

    function selectAssociatedServiceItems() {
      vm.showAssociatedServiceItems = true;
    }

    function onAssociatedServiceItemSaved(items) {
      vm.item.associated_service_items = items;
      vm.originalItem.associated_service_items = items;
      checkAssociatedServiceItemsSchedulesApplied();
    }

    function onAssociatedServiceItemDeleted(items) {
      vm.item.associated_service_items = items;
      vm.originalItem.associated_service_items = items;
      checkAssociatedServiceItemsSchedulesApplied();
    }

    // ----- ASSOCIATED TAXES -----

    function selectAssociatedTaxes(reload) {
      if (vm.taxes && !reload) return;

      let productCategoryAssociatedTaxes = {
        purchases: [],
        sales: [],
      };

      if (vm.item.product_category.associated_taxes) {
        vm.item.product_category.associated_taxes.map((associated_tax) => {
          if (associated_tax.scope_type === 'purchases') {
            productCategoryAssociatedTaxes.purchases.push(associated_tax);
          } else {
            productCategoryAssociatedTaxes.sales.push(associated_tax);
          }
        });
      }

      vm.taxes = TaxService.setAssociatedTaxes(
        productCategoryAssociatedTaxes,
        vm.item.associated_taxes,
        vm.taxTypes
      ); // vm.item.exonerations,

      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    function onAssociatedTaxesSaved(product) {
      if (!vm.customTaxConfiguration) {
        delete product.exonerations;
      }

      vm.item = product;
      vm.originalItem = angular.copy(vm.item);

      selectAssociatedTaxes(true);
    }

    function onAssociatedTaxesCanceled() {
      vm.customTaxConfiguration = vm.originalItem.custom_tax_configuration;

      vm.taxes = vm.taxesOriginal;
      vm.taxesOriginal = angular.copy(vm.taxes);
    }

    // ----- ACCOUNTING -----
    function selectAccounting() {
      vm.showAccounting = true;
    }

    // ----- COSTS AND PRICES -----

    function selectCostsAndPrices() {
      vm.showCostsAndPrices = false;

      setTimeout(() => {
        vm.showCostsAndPrices = true;
      }, 100); // hack

      // vm.showCostsAndPrices = true;
    }

    function onCostsAndPricesSaved(associated_providers) {
      vm.item.associated_providers = associated_providers;
      vm.originalItem.associated_providers = associated_providers;
    }
  }
})();
